import React, { useEffect, useState, useCallback, useMemo } from 'react';
import { InlineShareButtons, StickyShareButtons } from 'sharethis-reactjs';
import { getCookie, COOKIE_CONSENT_KEY } from "../../utils/cookies";

const ShareThis = (props) => {
	const [showWidget, setShowWidget] = useState(false);

	const networks = useMemo(() => {
		return props.includePocket
			? ['facebook', 'twitter', 'getpocket', 'email']
			: ['facebook', 'twitter', 'email'];
	}, [props.includePocket]);

	const commonConfig = useMemo(() => ({
		color: 'social',
		enabled: true,
		font_size: 16,
		labels: null,
		language: 'en',
		networks,
		padding: 12,
		radius: 0,
		url: props.url,
		image: props.image,
	}), [networks, props.url, props.image]);

	const buildInlineShareWidget = useCallback(() => (
		<InlineShareButtons
			config={{
				...commonConfig,
				alignment: 'center',
				show_total: false,
				size: 30,
			}}
		/>
	), [commonConfig]);

	const buildStickyShareWidget = useCallback(() => (
		<div className="sticky-share-landmark" aria-label="share-buttons" role="complementary">
			<StickyShareButtons
				config={{
					...commonConfig,
					alignment: 'left',
					hide_desktop: false,
					min_count: 10,
					show_total: true,
					show_mobile: false,
					show_toggle: props.toggle ?? false,
					size: 48,
					top: 300,
				}}
			/>
		</div>
	), [commonConfig, props.toggle]);

	useEffect(() => {
		const checkConsent = () => {
			const consent = getCookie(COOKIE_CONSENT_KEY);
			setShowWidget(consent === 'approved');
		};

		checkConsent();
	}, []);

	if (!showWidget) return null;

	switch (props.variant) {
		case 'inline':
			return buildInlineShareWidget();
		case 'sticky':
		default:
			return buildStickyShareWidget();
	}
};

export default React.memo(ShareThis);